// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.score-on-cancel-div[data-v-4baa0a78]{\n    margin-top: 1.5rem;\n}\n.reset-canecllation-href[data-v-4baa0a78] {\n    border-top: 1px solid #e8e8e8;\n    font-style: italic;\n    font-size: 1rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
